import { createAction } from '@reduxjs/toolkit';

export const carouselVisible = createAction('linkCarousel/carouselVisible');
